/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Autoclose2Inputs */

const en_coinvestments_autoclose2 = /** @type {(inputs: Coinvestments_Autoclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically close on closing date`)
};

/**
* | output |
* | --- |
* | "Automatically close on closing date" |
*
* @param {Coinvestments_Autoclose2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_autoclose2 = /** @type {((inputs?: Coinvestments_Autoclose2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Autoclose2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_autoclose2(inputs)
});
export { coinvestments_autoclose2 as "coInvestments_autoClose" }